import log from '../../lib/logger'

log.debug('Task.js loaded')

let state = {
    taskStates: [],
    project: {id: 0, project_ref: 'Unknown project'},
    currentTaskIndex: '',
    currentTask: '',
    currentTaskComponent: '',
    currentTaskAudioInstructions: false,
    currentResultId: null,
    userAbortStatus: false,
}

let originalTaskState = null

const mutations = {
    SET_TASKSTATUS(state, payload) {
        state.taskStates[payload.taskIndex].status = payload.status
    },
    SET_TASKCOMPONENT(state, payload) {
        log.debug('SET_TASKCOMPONENT')
        state.taskStates[payload.taskIndex].taskComponent = payload.component
        state.currentTaskComponent = payload.component
    },
    SET_PROJECT(state, payload) {
        log.debug('SET_PROJECT')
        state.project = payload
    },
    SET_TASKMETA(state, payload) {
        state.taskStates[payload.taskIndex].meta = payload.meta
    },
    SET_TASKMESSAGE(state, payload) {
        state.taskStates[payload.taskIndex].message = payload.message
    },
    SET_CURRENTTASK(state, taskIndex) {
        state.currentTaskIndex = taskIndex
        state.currentTask = state.taskStates[taskIndex].task
        state.currentTaskComponent = state.taskStates[taskIndex].taskComponent
    },
    RESET_TASK(state, payload) {
        state.taskStates[payload.taskIndex].taskComponent = 'instruction'
        state.taskStates[payload.taskIndex].meta = ''
        state.taskStates[payload.taskIndex].status = 'clean'
    },
    RESET_ALLTASKS(state, payload) {
        state.taskStates = originalTaskState
        state.currentTaskIndex = ''
        state.currentTask = ''
        state.currentTaskComponent = ''
    },
    SET_RESULT_ID(state, resultId) {
        state.currentResultId = resultId
    },
    // To be deprecated
    SET_TASK(state, task) {
        state.currentTask = task
    },
    SET_TASKSTATE(state, taskStates) {
        log.info('Setting taskstate %o', taskStates)
        originalTaskState = JSON.parse(JSON.stringify(taskStates))
        state.taskStates = taskStates
    },
    SET_USERABORTSTATUS(state, status) {
        log.info('Setting abortstatus to ' + status)
        state.userAbortStatus = status
    },
}

const actions = {
    // Current task actions
    updateCurrentTaskStatus: ({ commit, state }, status) => {
        let payload = {
            taskIndex: state.currentTaskIndex,
            status,
        }
        commit('SET_TASKSTATUS', payload)
        log.debug(payload)
        if (payload.status === 'completed' || payload.status === 'aborted') {
            for (var i = 0; i < state.taskStates.length; i++) {
                if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                    commit('SET_CURRENTTASK', i)
                    log.debug('current task', i)
                    log.debug('current task state', state.taskStates[i])
                    break
                }
            }
        }
    },
    updateCurrentTaskComponent: ({ commit, state }, component) => {
        log.info('updateCurrentTaskComponent (taskid: ' + state.currentTaskIndex + '): ' + component)
        let payload = {
            taskIndex: state.currentTaskIndex,
            component,
        }

        commit('SET_TASKCOMPONENT', payload)
    },
    updateCurrentTaskComponentConnected: ({commit, state}, component) => {
        log.info('updateCurrentTaskComponent (taskid: ' + (state.currentTaskIndex + 1) + '): ' + component)

        let payload = {
            taskIndex: state.currentTaskIndex + 1,
            component,
        }

        commit('SET_TASKCOMPONENT', payload)
    },
    updateCurrentResultId: ({ commit, state }, id) => {
        commit('SET_RESULT_ID', id)
    },
    updateCurrentTaskMeta: ({ commit, state }, meta) => {
        let payload = {
            taskIndex: state.currentTaskIndex,
            meta,
        }
        commit('SET_TASKMETA', payload)
    },
    updateCurrentTaskMessage: ({ commit, state }, message) => {
        let payload = {
            taskIndex: state.currentTaskIndex,
            message,
        }
        commit('SET_TASKMESSAGE', payload)
    },
    resetCurrentTask: ({ commit, state }) => {
        let payload = {
            taskIndex: state.currentTaskIndex,
        }
        commit('SET_RESETTASK', payload)
    },
    // Any task actions
    updateTaskStatus: ({ commit, state }, task, status) => {
        let payload = {
            taskIndex: task,
            status,
        }
        commit('SET_TASKSTATUS', payload)
    },
    updateTaskComponent: ({ commit, state }, task, component) => {
        log.info('updateTaskComponent (taskid: ' + task + '): ' + component)
        let payload = {
            taskIndex: task,
            component,
        }
        commit('SET_TASKCOMPONENT', payload)
    },
    updateTaskMeta: ({ commit, state }, task, meta) => {
        let payload = {
            taskIndex: task,
            meta,
        }
        commit('SET_TASKMETA', payload)
    },
    resetTask: ({ commit, state }, task) => {
        let payload = {
            taskIndex: task,
        }
        commit('SET_RESETTASK', payload)
    },
    resetAllTasks: ({ commit, state }) => {
        // Get original task state from server
        // then commit to store
        commit('SET_RESETALLTASKS')
    },
    // To be deprecated
    // resetTask: ({commit}, task) => {
    //   commit('SET_TASKCLEAN', task)
    // },
    changeTask: ({ commit }, task) => {
        commit('SET_TASK', task)
    },
    setProject: ({ commit }, project) => {
        commit('SET_PROJECT', project)
    },
    changeTaskComponent: ({ commit }, component) => {
        commit('SET_TASKCOMPONENT', component)
    },
    userAbortStatus: ({ commit }, status) => {
        commit('SET_USERABORTSTATUS', status)
    },
}

const getters = {
    currentTask: (state) => {
        log.debug('Getting current task...')
        for (var i = 0; i < state.taskStates.length; i++) {
            log.debug('Task: ' + state.taskStates[i].task + ' - ' + state.taskStates[i].status)
            if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                log.info('Returning "' + state.taskStates[i].task + '" as current task')
                state.currentTask = state.taskStates[i].task
                state.currentTaskIndex = i
                state.currentTaskAudioInstructions = state.taskStates[i].config.audioInstructions
                return state.taskStates[i].task
            }
        }
        return 'ERROR: Could not get current task!'
    },
    currentTaskState: (state) => {
        log.debug('Getting current task state...')
        return state.taskStates[state.currentTaskIndex]
    },
    currentProject: (state) => {
        log.debug('Getting current project state...')
        return state.project
    },
    currentTaskMessage: (state) => {
        for (var i = 0; i < state.taskStates.length; i++) {
            if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                return state.taskStates[i].message
            }
        }
        return 'ERROR: Could not get message!'
    },
    currentTaskComponent: (state) => {
        log.debug('Getting current task component...')
        for (var i = 0; i < state.taskStates.length; i++) {
            if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                log.info('Returning "' + state.taskStates[i].taskComponent + '" as current task component')
                state.currentTaskComponent = state.taskStates[i].taskComponent
                return state.taskStates[i].taskComponent
            }
        }
        return 'ERROR: Could not get current task component!'
    },
    nTasksCompleted: (state) => {
        for (var i = 0; i < state.taskStates.length; i++) {
            if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                return i
            }
        }
        return 'ERROR: Could not get current task completion number!'
    },
    nTasks: (state) => {
        return state.taskStates.length - 1
    },
    currentResultId: (state) => {
        return state.currentResultId
    },
    getUserAbortStatus: (state) => {
        return state.userAbortStatus
    },
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/task.js